<template>
    <div class="parent">
        <banner v-bind:bannerObj="bannerObj"></banner>
        <div class="newsWrap">
            <div class="navLeft">
                <ul>
                    <li class="active">
                        <router-link to="/">
                            <span>全部新闻</span>
                            <i>All News</i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/">
                            <span>公司动态</span>
                            <i>Company dynamics</i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/">
                            <span>行业新闻</span>
                            <i>All News</i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/">
                            <span>获奖认证</span>
                            <i>Award-winning</i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/">
                            <span>社会责任</span>
                            <i>Social responsibility</i>
                        </router-link>
                    </li>
                </ul>
            </div>
            <div class="newsRight">
                <div class="curmbsLink">
                    <a>首页</a>
                    <span> > </span>
                    <a>新闻动态</a>
                    <span> > </span>
                    <span>新闻详情</span>
                </div>
                <div class="newDetailImage">
                    <img src="../assets/images/write.png" alt="">
                </div>
                <div class="newDetailTitle">
                    <div class="mouth"><span>21</span><i>十二月</i></div>
                    <div class="textTitle">
                        <span>揭秘 | 如何在亚马逊北美站从懵懂小白到品类Best Seller？</span>
                        <p>外贸卖家Tony用一个半月的时间，就拿到了亚马逊所在品类的Best Seller.</p>
                        <div>
                            <a href="javascript:;">
                                <img src="../assets/images/share.png" alt="">
                                <span>打印</span>
                            </a>
                            <a href="javascript:;">
                                <img src="../assets/images/share.png" alt="">
                                <span>分享</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="newDescriptionDetail">
                    <p>广阔的大洋彼岸，美国、加拿大和墨西哥三国组成了亚马逊北美主要消费区域，拥有将近5亿人。</p>
                    <p>亚马逊北美一览 美国：美国电商市场规模庞大，连年保持2位数增长速度。亚马逊名列USA TOP 10网站排名第一，月均独立访客量达1.75亿。</p>
                    <p>加拿大：作为美国邻国，加拿大电商市场近年来发展迅速，网购渗透率达90%。加拿大拥有和美国相似消费习惯的消费者，相似的季节性，共享相似的畅销品类，且主要语言为英语。</p>
                    <p>墨西哥：作为拉美地区的电商引领者，受惠于人口增长和互联网普及率的提升，以及近期美国与拉美新签订的贸易协定，将为墨西哥电商发展带来更多机遇。</p>
                    <p>更令人惊喜的是，北美消费者对中国品牌以及中国产品的热捧程度：</p>
                    <p>■ 中国商品位于美国进口总额TOP1 2018年1-6月美国自中国的进口额为2497.4亿美元，增长8.6%，占美国进口总额的20.2%，相当于两个世界首富的财产总值（哇~~~！）</p>
                    <p>■ 美国消费者购买过的跨境电商所在地中，中国位居榜首，占56%。</p>
                    <p>与此同时，亚马逊北美的美国站、加拿大站和墨西哥站，还可以实现三站一键同步销售。</p>
                    <p>对中国卖家而言，亚马逊北美站最吸引人之处莫过于两大优势：其一，体量庞大，消费力强；其二，提供全中文注册平台，主要语言为英语，更方便新手卖家上手。</p>
                    <p>正是出于这样的考虑，原先做传统线下外贸的卖家Tony，在身边朋友们的推荐下，于2018年正式上线了亚马逊美国站。 从少量ASIN做起，打磨产品，研究广告投放，用一个半月的时间，就拿到了所在品类的Best Seller.</p>
                    <p>“我建议大部分卖家都可以把流量巨大的亚马逊美国站作为起点，你会发现销量增长的惊喜超乎想象！而且亚马逊不断创新的新功能、新工具都会先从美国站开始试点，这也算给新手们的一大‘福利’。”</p>
                    <p>从线下转线上，从懵懂小白到品类Best Seller，从传统贸易思维到电商数据思维，从简单定价逻辑到综合各种线上因素计算成本、利润和定价策略， 到如何寻得销量大且稳的ASIN，可谓历经摸索无数。</p>
                    <p>Tony大方地分享了针对北美新手卖家的“必读宝典”：</p>
                    <p>◆ 认真了解亚马逊的产品规则要求，特别是一些对专利性、安全性等要求很细的品类。对于刚做的新卖家，尽量不要选择季节性过强的品类。</p>
                    <p>◆ 不要以国内消费者对产品的认知来定义大洋彼岸的消费者，要综合考虑不同人群对产品的使用场景和习惯。</p>
                    <p>◆ 不要试图走“所谓”捷径来获取短期利益，前期要把产品描述、listing、站内推广等细节步步规划细致，即使“走”得相对慢一点也不要操之过急。</p>
                    <p>◆ 新手卖家预算不充足的情况下，不要盲目进行关键词投放，可以通过亚马逊的自动广告、分析竞争对手关键词等方法，找到转化率排名靠前的关键词，不断进行调整优化。</p>
                    <p>◆ 不要做“贪吃蛇”。新手上路，第一年可以先专心致志做好3-5个ASIN，以好产品打通运营快道。</p>
                    <p>◆ 亚马逊上Prime Day、黑五等都是新手卖家要好好利用的黄金流量活动。不仅要提前参加活动报名，并且至少提前3个月去进行备货、流量摸索和广告优化等等，才能在旺季收获“情理之中，意料之外”的惊喜。切勿临时抱佛脚，否则Prime Day过了，货还在路上。</p>
                    <p>◆ 保证供应链的出货速度跟得上自己的销量增长率，每个ASIN都能在断货前有新货源补上；如果采用海运和分批次等方法降低头程运输成本，时间预算要做足；之后可全程以FBA保证送货速度和提升用户退换货体验度。“当然，说到退换货体验的话，你要先把产品质量提上去，退货率自然就降低了。”Tony最后笑着补充道，“总之，未来我们会不断提升产品质量和设计，开发新品类和多品牌，继续以美国为主战场！”</p>
                </div>
            </div>
        </div>
        <footer>
            <footContent></footContent>
        </footer>
    </div>
</template>

<style lang="scss">
    .parent{
        background-color: #fff;
        .newsWrap {
            width: 1200px;
            margin: 80px auto;
            display: flex;
            flex-flow: nowrap row;
            justify-content: space-between;
            align-items: flex-start;
            .navLeft {
                width: 260px;
                ul {
                    li {
                        &.active {
                            background: rgba(230, 230, 230, 1);
                            a {
                                &:after { background: rgba(255, 203, 51, 1); }
                                span { color: rgba(18, 10, 76, 1); }
                                i { color: rgba(18, 10, 76, 0.6); }
                            }
                        }
                        padding: 20px;
                        border-bottom: 1px solid #ddd;
                        background: rgba(250, 250, 250, 1);
                        &:last-child { border-bottom: none; }
                        &:hover {
                            background: rgba(230, 230, 230, 1);
                        }
                        a {
                            display: block;
                            text-indent: 30px;
                            font-size: 14px;
                            text-align: left;
                            position: relative;
                            &:after {
                                content: '';
                                width: 6px;
                                height: 6px;
                                background: rgba(50, 50, 50, .6);
                                position: absolute;
                                top: 4px;
                                left: 10px;
                                z-index: 1;
                            }
                            &:hover:after {
                                 background: rgba(255, 203, 51, 1);
                             }
                            &:hover {
                                span {color: rgba(18, 10, 76, 1);}
                                i {color: rgba(18, 10, 76, .6);}
                            }
                            span {
                                display: block;
                                margin-bottom: 6px;
                                font-weight: bold;
                                color: rgba(50, 50, 50, 1);
                            }
                            i {
                                display: block;
                                color:rgba(50, 50, 50, .6);
                            }
                        }
                    }
                }
            }
            .newsRight {
                padding-left: 30px;
                flex: 1;
                .curmbsLink {
                    width: 100%;
                    line-height: 30px;
                    margin-bottom: 20px;
                    a { color: rgba(50,50,50, 0.3); }
                    a:hover { color: #323232; }
                }
                .newDetailImage {
                    padding-top: 20px;
                    margin: 40px 0;
                    border-top: 1px solid #ddd;
                    width: 100%;
                    img { width: 100%; height: auto; display: block;}
                }
                .newDetailTitle {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 40px;
                    .mouth {
                        width: 100px;
                        height: 120px;
                        background: rgba(18, 10, 76, .4);
                        display: flex;
                        flex-flow: column nowrap;
                        justify-content: center;
                        align-items: center;
                        color: #fff;
                        span {
                            display: block;
                            margin-bottom: 10px;
                            font-size: 30px;
                            font-weight: 900;
                        }
                        i {font-size: 16px;}
                    }
                    .textTitle {
                        flex: 1;
                        padding-left: 30px;
                        display: flex;
                        flex-flow: column nowrap;
                        justify-content: center;
                        align-items: flex-start;
                        span {
                            display: block;
                            font-size:24px;
                            font-weight: bold;
                            margin-bottom: 15px;
                        }
                        p {
                            display: block;
                            color:rgba(50, 50, 50, .5);
                            font-size: 16px;
                            margin-bottom: 20px;
                        }
                        div {
                            display: flex;
                            flex-flow: row nowrap;
                            justify-content: flex-start;
                            align-items: center;
                            a {
                                display: flex;
                                flex-flow: row nowrap;
                                justify-content: center;
                                align-items: flex-start;
                                margin-right: 20px;
                                img {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    margin-right: 15px;
                                }
                                span { font-size: 16px; margin: 0; }
                            }
                        }
                    }
                }
                .newDescriptionDetail {
                    p { line-height: 34px; }
                }
            }
        }
    }
</style>


<script>
import store from '../vuex'
import DetailBanner from '../components/DetailBanner'
import FootContent from "../components/FootContent";
// import Child from '../components/Child.vue'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/news.png'),
            text: 'NEWS',
        }
      }
  },
  components:{
    'banner': DetailBanner,
    'footContent': FootContent,
  },
  store,
}
</script>

